import { useEffect, useState } from "react";

import Loading from "app/pages/home/components/Loading";
import useQuizFormModel from "./hooks/useQuizFormNewModel";
import { QuestionsList } from "../Quiz/Questions";
import QuestionForm from "./update/QuestionForm";
import { QuizFormView } from "./components";
import { LocaliseAPIService } from "app/services/Localise/localiseApi";

import { CognitiveCategoryType, QuizType } from "app/types";

type QuizNewViewProps = ReturnType<typeof useQuizFormModel>;

const localiseApiService = LocaliseAPIService.getInstance();

// provisório

export const getAudiometryCategory = (id: number) => {
  const newAudiometryCategory = audiometryCategory.find(
    audiometry => audiometry.categoryCognitiveQuestionId === id,
  );

  return newAudiometryCategory ? newAudiometryCategory.name : "N/A";
};

// type AudioDeviceType = "speaker" | "headphones";

export const audiometryCategory: CognitiveCategoryType[] = [
  { categoryCognitiveQuestionId: 1, name: "Fase 01", tagLocalise: "TESTE1" },
  { categoryCognitiveQuestionId: 2, name: "Fase 02", tagLocalise: "TESTE2" },
  { categoryCognitiveQuestionId: 3, name: "Fase 03", tagLocalise: "TESTE3" },
  { categoryCognitiveQuestionId: 4, name: "Fase 04", tagLocalise: "TESTE4" },
];

const QuizNewView = ({
  loading,
  translate,
  styleInput,
  register,
  errors,
  control,
  campaigns,
  quizData,
  id,
  watch,
  getQuizById,
  onCleanQuestion,
  selectedQuestion,
  openQuestionModal,
  setOpenQuestionModal,
  questions,
  setUserIds,
  campaign,
  onDelete,
  onEdit,
  userIds,
  language,
  setLanguage,
  onSubmitForm,
  selectTheTypeQuiz,
  onClone,
  selectedType,
  handleChangeType,
}: QuizNewViewProps) => {
  const [cognitiveCategories, setCognitiveCategories] = useState<
    CognitiveCategoryType[]
  >([]);
  const [audiometryCategories, setAudiometryCategories] = useState<
    CognitiveCategoryType[]
  >([]);

  const audioDevice = [
    {
      value: "speaker",
      name: translate("screens_table_audiometry_audio_device_type_speaker"),
    },
    {
      value: "headphones",
      name: translate("screens_table_audiometry_audio_device_type_headphones"),
    },
  ];

  const audioChannel = [
    {
      id: 1,
      value: "left",
      name: translate("screens_labels_left"),
    },
    {
      id: 2,
      value: "both",
      name: translate("screens_labels_both"),
    },
    {
      id: 3,
      value: "right",
      name: translate("screens_labels_right"),
    },
  ];

  useEffect(() => {
    const start = async () => {
      const data = await localiseApiService.getCategories();
      if (data) {
        setCognitiveCategories(data);
      }

      setAudiometryCategories(audiometryCategory);
    };
    start();
  }, []);

  const watchedQuizId = Number(id) || quizData?.quizId || watch("quizId");

  const handleChangeUserIds = (userIds: string) => {
    setUserIds(userIds);
  };

  const getCategoryCognitiveBy = (id: number): string => {
    if (!id) {
      return "N/A";
    }
    const cognitiveCategory = cognitiveCategories.find(
      category => category.categoryCognitiveQuestionId === id,
    );
    return cognitiveCategory?.name || "N/A";
  };

  return (
    <div style={{ padding: "10px" }}>
      <Loading isLoading={loading} />
      <QuizFormView
        translate={translate}
        styleInput={styleInput}
        register={register}
        errors={errors}
        control={control}
        campaigns={campaigns}
        setUserIds={handleChangeUserIds}
        userIds={userIds}
        language={language}
        setLanguage={setLanguage}
        selectTheTypeQuiz={selectTheTypeQuiz}
        selectedType={selectedType}
        handleChangeType={handleChangeType}
        onSubmitForm={onSubmitForm}
        campaign={campaign}
        watch={watch}
        id={id}
        onClone={onClone}
      />
      {watchedQuizId ? (
        <QuestionsList
          collections={campaign.collection}
          questions={questions}
          quiz={quizData || ({} as QuizType)}
          onEdit={onEdit}
          onClone={onClone}
          onDelete={onDelete}
          onAdd={() => setOpenQuestionModal(true)}
          onRefresh={() => {
            getQuizById(watchedQuizId);
            onCleanQuestion();
          }}
          getCategoryCognitiveBy={getCategoryCognitiveBy}
        />
      ) : null}

      <QuestionForm
        collections={campaign.collection}
        handleClose={() => setOpenQuestionModal(false)}
        open={openQuestionModal}
        question={selectedQuestion}
        onFinish={quizId => {
          getQuizById(quizId);
          onCleanQuestion();
        }}
        quizId={watchedQuizId}
        quiz={quizData || ({} as QuizType)}
        cognitiveCategories={cognitiveCategories}
        audiometryCategories={audiometryCategories}
        audioDeviceType={audioDevice}
        audioChannel={audioChannel}
      />
    </div>
  );
};

export default QuizNewView;
